import { MessageCircle, Users, CalendarCheck, Newspaper, LineChart, Compass } from "lucide-react";
import { Reveal } from "./Reveal";

const PERKS = [
  {
    icon: MessageCircle,
    title: "Atención personalizada",
    body: "Acompañamiento directo por WhatsApp para resolver tus dudas.",
  },
  {
    icon: Users,
    title: "Comunidad privada",
    body: "Un grupo exclusivo donde trabajamos todos juntos.",
  },
  {
    icon: CalendarCheck,
    title: "Reviews semanales",
    body: "Revisiones de operativas reales, semana a semana.",
  },
  {
    icon: Newspaper,
    title: "Contenido constante",
    body: "Nuevas publicaciones y actualizaciones de forma continua.",
  },
  {
    icon: LineChart,
    title: "Backtesting adicional",
    body: "Nuevos backtests y material extra dentro del curso.",
  },
  {
    icon: Compass,
    title: "Seguimiento del proceso",
    body: "Resolución de dudas y acompañamiento durante todo el camino.",
  },
];

export const Formation = () => (
  <section
    data-testid="formation-section"
    className="relative border-t border-[#5EA2FF]/15 bg-[#030D20] px-6 py-28 sm:px-12 lg:px-20 lg:py-40"
  >
    <div className="grid grid-cols-1 gap-16 lg:grid-cols-[1fr_1.2fr] lg:gap-24">
      <div className="min-w-0">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.4em] text-[#5EA2FF] sm:text-xs">
            {"// 02 — LA FORMACIÓN"}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 flex flex-wrap items-start gap-6">
            <span className="text-stroke-blue font-display text-[clamp(4.5rem,22vw,11rem)] font-extrabold leading-none">
              28
            </span>
            <div className="min-w-0 pt-6">
              <p className="font-display text-2xl font-bold uppercase leading-tight text-white sm:text-3xl">
                Clases
                <br />
                progresivas
              </p>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-md text-sm leading-relaxed text-[#7A90B8] sm:text-base">
            De los fundamentos más importantes a la ejecución avanzada: gestión del
            riesgo, psicología y análisis profesional. Con ejemplos reales, tips
            prácticos y análisis aplicados basados en experiencia real dentro del mercado.
          </p>
        </Reveal>
      </div>

      <div className="grid min-w-0 grid-cols-1 gap-px self-center overflow-hidden border border-[#5EA2FF]/15 bg-[#5EA2FF]/15 sm:grid-cols-2">
        {PERKS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07} className="bg-[#030D20]">
            <div className="group h-full p-7 transition-colors duration-500 hover:bg-[#061226]">
              <p.icon className="h-6 w-6 text-[#2F7DF6] transition-colors duration-500 group-hover:text-[#5EA2FF]" />
              <h3 className="mt-5 font-display text-base font-bold uppercase tracking-tight text-white">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#7A90B8]">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
